module.exports = __webpack_public_path__ + "img/ImportProfile_Mockup.c501e925.png";